export const MESSAGE_INPUT_MAX_LENGTH = 2000;
export const EVENT_STUDENT_EVALUATED_MESSAGE = 'tutorbot:student_evaluated_message';
